import { ROUTE_PATHS } from 'Constants/routing';

/**
 * Get current path from window.location
 */
export const getCurrentPath = (): string => {
  return window.location.pathname;
};

/**
 * Check if the current path matches a specific route
 * @param routePath - The route path to match against
 * @returns boolean - True if the paths match
 */
export const isCurrentPath = (routePath: string): boolean => {
  return getCurrentPath() === routePath;
};

/**
 * Check if the current path includes a specific route segment
 * @param routeSegment - The route segment to look for
 * @returns boolean - True if the path includes the segment
 */
export const isCurrentPathIncluding = (
  routeSegment?: string,
  routeRegex?: RegExp
): boolean => {
  const currentPath = getCurrentPath();
  if (!currentPath) {
    return false;
  }

  if (routeSegment) {
    return currentPath.includes(routeSegment);
  }

  if (routeRegex) {
    return routeRegex.test(currentPath);
  }

  return false;
};

/**
 * Predefined route checks
 */
export const routeChecks = {
  isNewConversationPage: () => isCurrentPath(ROUTE_PATHS.newConversation.path),
  isChatPage: () => isCurrentPathIncluding('/chat'),
  isCallsPage: () => isCurrentPathIncluding('/calls'),
  isVideoAppPage: () => isCurrentPathIncluding('/video-app'),
  isSettingsPage: () => isCurrentPathIncluding('/settings'),
  isAddressBookPage: () => isCurrentPathIncluding('/addressBook'),
  isDirectoryPage: () => isCurrentPathIncluding('/directory'),
  isFaxPage: () => isCurrentPathIncluding('/fax'),
  isVoicemailPage: () => isCurrentPathIncluding('/voicemail'),
  isVideoHistoryDetailsPage: () =>
    isCurrentPathIncluding(undefined, /\/video-app\/history\/[0-9]+/),
};
